import {SUPPORT} from './supportActionTypes';

export function sendSupportMessage(data) {
  return {
    type: SUPPORT.SEND_MESSAGE,
    payload: {
      client: 'default',
      request: {
        url: `/support`,
        method: 'post',
        data
      }
    }
  };
}
